import Admin from "@/views/admin/Admin.vue";

export default {
  path: "/admin",
  component: Admin
};
